import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import '../assets/css/styles.css';
/* import RenderOnAnonymous from "./RenderOnAnonymous";
import RenderOnAuthenticated from "./RenderOnAuthenticated"; */
import RenderOnLogin from './RenderOnLogin';
import Landing from '../pages/Landing';
import Signup from '../pages/Signup';
import Applications from '../pages/Applications';
import Estimate from '../pages/Estimate';
import TermsOfService from '../pages/TermsOfService';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import Admin from '../pages/Admin';
import KYCValidation from '../pages/KYCValidation';

function App() {
  return (
    <BrowserRouter>
      {/* <RenderOnAnonymous />
      <RenderOnAuthenticated>
        <Routes>
          <Route path="/" element={<Signup />} />
          <Route path="/users" element={<Users />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/prospect" element={<Estimate />} />
        </Routes>
      </RenderOnAuthenticated> */}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/customer" element={<RenderOnLogin><Signup /></RenderOnLogin>} />
        <Route path="/applications" element={<RenderOnLogin><Applications /></RenderOnLogin>} />
        <Route path="/estimator" element={<Estimate />} />
        <Route path="/TermsOfService" element={<TermsOfService />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/admin" element={<RenderOnLogin><Admin /></RenderOnLogin>} />
        <Route path="/kyc-validation" element={<KYCValidation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
